"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importStar(require("../Button/Button"));
var IconButton_1 = __importStar(require("../IconButton/IconButton"));
var Cart_1 = __importDefault(require("../Icons/Cart/Cart"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var MAX_ITEM_COUNT = 99;
var CartWithCountButtonV2 = function (props) {
    var defaultProps = {
        disabled: false,
        showBackground: false,
        showBorder: false,
        itemCount: 0,
    };
    var _a = __assign(__assign({}, defaultProps), props), ariaLabel = _a.ariaLabel, children = _a.children, disabled = _a.disabled, itemCount = _a.itemCount, onClick = _a.onClick, showBackground = _a.showBackground, showBorder = _a.showBorder, rest = __rest(_a, ["ariaLabel", "children", "disabled", "itemCount", "onClick", "showBackground", "showBorder"]);
    return (react_1.default.createElement(react_1.default.Fragment, null, itemCount > 0 ? (react_1.default.createElement(Button_1.default, { "aria-label": ariaLabel, onClick: onClick, theme: Button_1.ButtonThemeTypes.mighty, size: Button_1.ButtonSizeTypes.small, postIcon: react_1.default.createElement(Cart_1.default, null) }, itemCount && itemCount > MAX_ITEM_COUNT
        ? "".concat(MAX_ITEM_COUNT, "+")
        : "".concat(itemCount))) : (react_1.default.createElement(IconButton_1.default, __assign({ ariaLabel: ariaLabel, onClick: onClick, showBackground: showBackground, showBorder: showBorder, size: IconButton_1.IconButtonSizes.large }, rest),
        react_1.default.createElement(Cart_1.default, { size: b2c_theme_1.IconSizes.medium })))));
};
exports.default = CartWithCountButtonV2;
//# sourceMappingURL=CartWithCountButtonV2.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/CartWithCountButtonV2/CartWithCountButtonV2.js
// module id = 1274
// module chunks = 81